import moment from "moment";
import Icon from "../Icon/Icon.js";
import { PassCodeContainer as StyledPassCodeContainer } from "./PassCodeContainer.styles.js";
import OtpContainer from "../OtpContainer/OtpContainer"
import DocumentInputFieldContainer from "../DocumentInputFieldContainer/DocumentInputFieldContainer"

import "./index.scss";

const currentYear = moment().format('YYYY');

const PassCode = ({
	loading,
	passCodeTypeMessage,
	isCpf,
	submit
}) => (
	<StyledPassCodeContainer className="doca">
		<StyledPassCodeContainer.InfoContainer className="doca-flex doca-flex-col doca-justify-between doca-w-full doca-p-6">
			<div>
				<p className="doca-text--bold doca-text--large doca-text-center doca-my-5">
					Verificação de segurança
				</p>
				<p className="doca-text--medium doca-text--extra-small doca-text-center doca-my-5">
					Valide sua identidade para ter acesso ao documento.
				</p>
				<p className="doca-text--medium doca-text--extra-small doca-text-center doca-my-5">
					{passCodeTypeMessage}.
				</p>
			</div>

			{isCpf
				? <OtpContainer onSubmit={submit} loading={loading}></OtpContainer>
				: <DocumentInputFieldContainer onSubmit={submit} loading={loading}></DocumentInputFieldContainer>
			}
		</StyledPassCodeContainer.InfoContainer>

		<footer className="doca-flex doca-items-center doca-justify-center doca-w-full doca-flex-col">
			<div
				className="doca-flex doca-items-center doca-justify-center doca-gap-4 doca-mt-6"
				style={{ marginBottom: "32px" }}
			>
				<i className="doca-icon doca-icon__lock doca-icon--regular doca-text--gray" />

				<span className="doca-text doca-text--extra-small doca-text--gray">
					Este site está protegido por reCAPTCHA e pela <br />
					<a
						id="privacy-link"
						target="_blank"
						rel="noreferrer"
						href="https://drive.google.com/file/d/1O8hDS3SGx_jDPjL_eRZoiBxbJl_l0gB4/view?usp=drive_link"
						style={{
							textDecoration: "underline",
							cursor: "pointer",
						}}
					>
						Política de Privacidade
					</a> e <a
						style={{
							textDecoration: "underline",
							cursor: "pointer",
						}}
						href="https://drive.google.com/file/d/11f07WOLbgle_cbea8rGH7mq3d_ur982I/view?usp=drive_link"
						id="terms-link"
						target="_blank"
						rel="noreferrer"
					>
						Termos de Uso do Google
					</a>
				</span>
			</div>

			<div className="doca-flex doca-items-center">
				<Icon name="amigo-logo-gray" marginRight={4} />
				<br />
				<span className="doca-text doca-text--extra-small doca-text--gray">
					Cuide mais e melhor.
				</span>
			</div>
			<div className="doca-flex doca-items-center doca-mt-2 doca-mb-4">
				<span className="doca-text doca-text--extra-small doca-text--gray">
					{currentYear}, AmigoTech S/A. Todos os direitos reservados.
				</span>
			</div>
		</footer>
	</StyledPassCodeContainer>
);

export default PassCode;
